import { useEffect, useRef, useState } from 'react';
// import logo from './logo.png';
// import office1 from './images/office1.png';
import './App.css';
// import Schedule from './schedule';
// import { useNavigate } from 'react-router-dom';
// import redbird1 from './images/redbird1.jpeg';
// import vid1 from './videos/vid1.mp4';
import { createClient } from '@supabase/supabase-js'


function EarlyAccess() {
  var roles1 = ["Aviation Enthusiast", "Ground Instructor", "Student Pilot", "Private Pilot","Instrument Rated", "Commercial Pilot", "CFI", "CFII", "ATP", "DPE (Designated Pilot Examiner)", "Other Aviation Professional"];
  var lookingForRecreational = ["Recreational Simulator Time"]
  var lookingForTraining = ["Instrument Currency", "Instrument Training", "Private Pilot Training","Avionics Proficiency", "Other (Please leave comment in message box)"];
  var lookingForExams = ["Mock Checkride Oral Location", "Checkride Oral Location"]
  var lookingForArray = [lookingForRecreational, lookingForTraining, lookingForExams];

  var client = createClient("https://pxhwanpwfyjthzcaqfcd.supabase.co","sb_publishable_J8lmYFYBMortGqx5bwu6YQ_CdAAZloB")
  var [roles,setRoles] = useState<string[]>(roles1);
  var [roleMap, setRoleMap] = useState<Map<string, boolean>>(new Map);
  var [locationMap, setLocationMap] = useState<Map<string, boolean>>(new Map);
  var [zipCode, setZipCode] = useState<string>('');
  var [floridaBased,setFloridaBased] = useState<boolean>(false);
  var [baseAirport, setBaseAirport] = useState<string>('');
  var [aircraft, setAircraft] = useState<string>('');
  var [avionics, setAvionics] = useState<string>('');
  var [interestMap, setInterestMap] = useState<Map<string, boolean>>(new Map);
  var [mailing, setMailing] = useState<boolean>(true);
  var [firstName, setFirstName] = useState<string>('');
  var [lastName, setLastName] = useState<string>('');
  var [email, setEmail] = useState<string>('');
  var [message,setMessage] = useState<string>('');


  function scrollTo(refTarget: any) {
    refTarget.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function requiredField() {
    return (
      <span style={{ color: "red" }}>*</span>
    );
  }

  function subtext(text: string) {
    return (
      <>
        <br /><span style={{ fontSize: "0.8rem", fontStyle: "italic" }}>{text}</span>
      </>
    );
  }

  function lowerCaseEmail(){
    return email.toLowerCase();
  }
  async function submitEntry(){
    if(email == ''){
      alert("please fill in required entries");
      return;
    }
    if(!(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email))){
      alert("Email is not valid");
      return;
    }
    var [date,time] = new Date().toISOString().split('T');
    var [year,month,day] = date.split('-');
    const {data,error} = await client.from('early_access').insert({
      email:lowerCaseEmail(),
      first_name:firstName,
      last_name:lastName,
      time:time,
      year:year,
      month:month,
      day:day,
      mailing_list:mailing})
    console.log(data);

    const returnPackage2 = await client.from('early_access_roles').insert({
      email:lowerCaseEmail(),
      aviation_enthusiast:roleMap.get(roles[0]),
      ground_instructor:roleMap.get(roles[1]),
      student_pilot:roleMap.get(roles[2]),
      private_pilot:roleMap.get(roles[3]),
      instrument_rated:roleMap.get(roles[4]),
      commercial_pilot:roleMap.get(roles[5]),
      cfi:roleMap.get(roles[6]),
      cfii:roleMap.get(roles[7]),
      atp:roleMap.get(roles[8]),
      dpe:roleMap.get(roles[9]),
      other:roleMap.get(roles[10]),
    })

    const returnPackage3 = await client.from('early_access_services').insert({
      email:lowerCaseEmail(),
      recreational_time:interestMap.get(lookingForRecreational[0]),
      instrument_currency:interestMap.get(lookingForTraining[0]),
      instrument_training:interestMap.get(lookingForTraining[1]),
      private_training:interestMap.get(lookingForTraining[2]),
      avionics:interestMap.get(lookingForTraining[3]),
      other:interestMap.get(lookingForTraining[4]),
      mock_checkride:interestMap.get(lookingForExams[0]),
      checkride_oral:interestMap.get(lookingForExams[1]),
    })

    const returnPackage4 = await client.from('early_access_locations').insert({
      email:lowerCaseEmail(),
      florida_based:floridaBased,
      zip_code:zipCode,
      base_airport:baseAirport
    });

    const returnPackage5 = await client.from('early_access_messages').insert({
      email:lowerCaseEmail(),
      messages:message,
    })

    const returnPackage6 = await client.from('early_access_equipment').insert({
      email:lowerCaseEmail(),
      aircraft:aircraft,
      avionics:avionics
    })
    
    if(error || returnPackage2.error || returnPackage3.error || returnPackage4.error || returnPackage5.error || returnPackage6.error){
         console.log(error);
         alert("Submission Error");
    } else {
      alert("Thank you for your submission. \n Please feel free to share this form with others in the aviation community! ");
    }
  }

  useEffect(()=>{
    // getTableHeaders();
  },[])

  
  // var roleSubmission = []
  // var lookingForSubmission = []
  // , "Student Pilot", "Private Pilot", "Commercial Pilot", "Independent Instructor","CFI", "CFII", "ATP", "Other Aviation Professional"
  function handleSelection(target: string, input: string) {
    switch (target) {
      case "role":
        var tempMap1 = new Map(roleMap);
        if (tempMap1.get(input) == null) {
          tempMap1.set(input, false)
        }
        tempMap1.set(input, !roleMap.get(input))
        setRoleMap(tempMap1);
        console.log("Role Map:");
        console.log(roleMap);
        break;
      case "interest":
        var tempMap2 = new Map(interestMap);
        if (tempMap2.get(input) == null) {
          tempMap2.set(input, false)
        }
        tempMap2.set(input, !interestMap.get(input))
        setInterestMap(tempMap2);
        console.log("Interest Map:");
        console.log(interestMap);
        break;
      case "location":
        var tempMap3 = new Map(locationMap);
        if (tempMap3.get(input) == null) {
          tempMap3.set(input, false)
        }
        tempMap3.set(input, !locationMap.get(input))
        setLocationMap(tempMap3);
        console.log("Location Map:");
        console.log(locationMap);
        break;
      default:
        break;
    }

  }


  async function getTableHeaders(){
    const {data,error} = await client.from('early_access_roles').select("*").limit(1)
    if(error){
      return;
    }
    if(data) {
      var headers = (Object.keys(data[0]));
      console.log("headers");
      console.log(headers);
      setRoles(headers);
    }
  }

  function clearForm(){
    setRoleMap(new Map);
    setLocationMap(new Map);
    setZipCode('');
    setFloridaBased(false);
    setBaseAirport('');
    setInterestMap(new Map);
    setMailing(false);
    setFirstName('');
    setLastName('');
    setEmail('');
    setMessage('');
    setAircraft('');
    setAvionics('');
  }

  // var [roleMap, setRoleMap] = useState<Map<string, boolean>>(new Map);
  // var [locationMap, setLocationMap] = useState<Map<string, boolean>>(new Map);
  // var [zipCode, setZipCode] = useState<string>('');
  // var [floridaBased,setFloridaBased] = useState<boolean>(false);
  // var [baseAirport, setBaseAirport] = useState<string>('');
  // var [interestMap, setInterestMap] = useState<Map<string, boolean>>(new Map);
  // var [mailing, setMailing] = useState<boolean>(true);
  // var [firstName, setFirstName] = useState<string>('');
  // var [lastName, setLastName] = useState<string>('');
  // var [email, setEmail] = useState<string>('');
  // var [message,setMessage] = useState<string>('');

  return (
    <>
      <div className="landingPageItemCenter" style={{ margin: 0, padding: 0, position: "relative" }}>
        <h1>Early Access Interest Form</h1>
        <div className="interestForm" style={{display: "grid", gridTemplateColumns: "1fr 2fr", gap: 10, width: "70vw", maxWidth: "80%", padding: 20 }}>
          <h2>Email{requiredField()}</h2>
          <input type="text" value={email} onChange={e=> setEmail(e.target.value)}placeholder="Enter your email here"></input>
          <h2>First Name</h2>
          <input type="text" value={firstName} onChange={e=> setFirstName(e.target.value)}placeholder="Enter your first name here"></input>
          <h2>Last Name</h2>
          <input type="text" value={lastName} onChange={e=> setLastName(e.target.value)}placeholder="Enter your last name here"></input>
                    {/* <h2>Phone Number</h2>
    <input type="text" placeholder="Enter your email here"></input> */}

    <h2>What services interest you?{subtext("Choose all that apply")}</h2>
          <div style={{ display: "flex", flexDirection: "column", textAlign: "start", maxHeight: "fit-content", overflowY: "scroll", border: "1px solid black", padding: 10 }}>
            

            <p style={{ textDecoration: "underline" }}>Training and Currency</p>
            {lookingForTraining.map((interest,i) => {
              return (
                <label key={i} className="checkBoxLabel">
                  <input style={{
                    marginRight: 10,
                    marginBottom: 10,
                    padding: 5
                  }} type="checkbox" checked={interestMap.get(interest)  ?? false} onChange={() => handleSelection("interest", interest)}></input>
                  {interest}
                </label>
              )
            })}
            <p style={{ textDecoration: "underline" }}>Examinations</p>
            {lookingForExams.map((interest,i) => {
              return (
                <label key={i} className="checkBoxLabel">
                  <input style={{
                    marginRight: 10,
                    marginBottom: 10,
                    padding: 5
                  }} type="checkbox" checked={interestMap.get(interest)  ?? false} onChange={() => handleSelection("interest", interest)}></input>
                  {interest}
                </label>
              )
            })}

            <p style={{ textDecoration: "underline" }}>Recreational</p>

            {lookingForRecreational.map((interest,i) => {
              return (
                <label key={i} className="checkBoxLabel">
                  <input style={{
                    marginRight: 10,
                    marginBottom: 10,
                    padding: 5
                  }} type="checkbox" checked={interestMap.get(interest)  ?? false} value={interest} onChange={() => handleSelection("interest", interest)}></input>
                  {interest}
                </label>
              )
            })}
          </div>

          <h2>Which Best Describes You?{subtext("Choose all that apply")}</h2>
          <div style={{ display: "flex", flexDirection: "column", textAlign: "start", maxHeight: "fit-content", overflowY: "scroll", border: "1px solid black", padding: 10 }}>
            {roles.map((role,i) => {
              return (
                <label key={i} className="checkBoxLabel">
                  <input style={{
                    marginRight: 10,
                    marginBottom: 10,
                    padding: 5
                  }} type="checkbox" checked={roleMap.get(role) ?? false}  onChange={() => handleSelection("role", role)}></input>
                  {role}
                </label>
              )
            })}
          </div>

          {/* <h2>Current Flight Experience</h2>
          <div style={{ display: "flex", flexDirection: "column", textAlign: "start", maxHeight: "fit-content", overflowY: "scroll", border: "1px solid black", padding: 10 }}>
            <label>
              Flight Hours:
              <input type="text" placeholder="Enter your email here"></input>
            </label>

            <label>
              Flight Hours:
              <input type="text" placeholder="Enter your email here"></input>
            </label>
          </div>
           */}

          <h2>Where are you based?{subtext("Choose/Fill Out all that apply")}</h2>
          <div style={{ display: "flex", flexDirection: "column", textAlign: "start", maxHeight: "fit-content", overflowY: "scroll", border: "1px solid black", padding: 10 }}>
            <label>
            <p style={{textDecoration:"underline",textUnderlineOffset:"0.2rem"}}>Are you based in South Florida?</p>
            <input type="checkbox" checked={floridaBased} onChange={() => setFloridaBased(!floridaBased)}></input>
</label>
            <label>
              <p style={{textDecoration:"underline",textUnderlineOffset:"0.2rem"}}>Zip Code</p>
                <input type="text" value={zipCode} onChange={e=>setZipCode(e.target.value)} placeholder='ex. 34994'></input>
            </label>
            <label >
              <p style={{textDecoration:"underline",textUnderlineOffset:"0.2rem"}}>Home Airport Identifier</p>
              <input type="text" value={baseAirport} onChange={e=>setBaseAirport(e.target.value)} placeholder='ex. KSUA'></input>
            </label>
          </div>


          <h2>What aircraft and avionics do you have experience with, or use/train on most often?{subtext("List in the text fields")}</h2>
          <div style={{ display: "flex", flexDirection: "column", textAlign: "start", maxHeight: "fit-content", overflowY: "scroll", border: "1px solid black", padding: 10 }}>
            
            <label>
              <p style={{textDecoration:"underline",textUnderlineOffset:"0.2rem"}}>Aircraft</p>
                <textarea style={{minWidth:"50%",minHeight:"3rem"}}value={aircraft} onChange={e=>setAircraft(e.target.value)} placeholder='ex. "C182R, C172N, PA-28"'></textarea>
            </label>

            <label >
              <p style={{textDecoration:"underline",textUnderlineOffset:"0.2rem"}}>Avionics</p>
              <textarea style={{minWidth:"50%",minHeight:"3rem"}}value={avionics} onChange={e=>setAvionics(e.target.value)} placeholder='ex. "Garmin G500txi,G5, GTN650"'></textarea>
            </label>
          </div>




          

          <h2>Would you like to join the early access mailing list?{subtext("Uncheck to opt-out of mailing list")}</h2>
          <input type="checkbox" checked={mailing} onChange={() => setMailing(!mailing)}></input>
          <h2 style={{ width: "100%", gridColumn: "span 2" }}>Leave a Message!</h2>
          <textarea style={{ minHeight: 100, maxWidth: "100%", gridColumn: "span 2", padding: 10 }}
            placeholder="Enter your questions or comments here and we will aim to get back to you!" value={message} onChange={e=> setMessage(e.target.value)}></textarea>
          <button style={{ width: "100%", gridColumn: "span 2" }} onClick={()=>submitEntry()}>
            Submit
          </button>
        
          <button style={{width: "100%", color:"white",backgroundColor:"red", gridColumn: "span 2" }} onClick={()=>clearForm()}>
            Clear Form
          </button>
        </div>





        {/* <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 20, maxWidth: "100%" }}>
              
        </div> */}
      </div>
      {/* <div style={{color:"white",position:"absolute",top:"30%",padding:50,backgroundColor:"#0000006d",fontSize:"1rem"}} id="topOverlay" className="genericFlexColumn">
          <h1>Simulator</h1>
          <button onClick={()=> scrollTo(moreTarget) }>See More</button>
        </div>
        <video src={"/videos/redbirdDescentClip1.mp4"} autoPlay playsInline muted></video>
      </div> */}

      {/* <div ref={moreTarget} className="landingPageItemCenter">
         <p>Private Environment on the Treasure Coast with Office, Desk, Computer, and Aviation Training Supplies for independent CFI's to conduct ground lessons with a co-located simulator for easy access to demonstration & practice tools for their students.</p>
      <p>Book time for your and your students to maximize their training and amplify the value of your personal brand as a flight instructor in an increasingly competitive market</p>
      <p>Instructor Rate Available on a per student basis. Independent Student Practice Rate Available.</p>
      <p>30 Minute Drive from KFPR. 45 Minute Drive from KVRB. 45 Minute Drive from KPBI. 5 Minute Drive from KSUA</p>
      <p>Located Near Downtown Stuart in a Thriving plaza. Located Right above: Ichimaru. Located Near: Epic Theaters, Toojays </p>
      <p>Located near KSUA. An airport with high flight training presence.</p>
      <p>Dedicated Space for: Mock Checkrides, Simulator Training, IFR Training</p>
      <p>Loggable Hours for IFR Currency. PPL Training.</p>
      </div> */}
    </>

  );
}

export default EarlyAccess;
